import { render, staticRenderFns } from "./ExternalChangesHistory.vue?vue&type=template&id=56007810&scoped=true&"
import script from "./ExternalChangesHistory.vue?vue&type=script&lang=js&"
export * from "./ExternalChangesHistory.vue?vue&type=script&lang=js&"
import style0 from "./ExternalChangesHistory.vue?vue&type=style&index=0&id=56007810&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "56007810",
  null
  
)

export default component.exports

/* vuetify-loader */
import installComponents from "!../../../node_modules/vuetify-loader/lib/runtime/installComponents.js"
import { VCard } from 'vuetify/lib/components/VCard';
import { VCol } from 'vuetify/lib/components/VGrid';
import { VContainer } from 'vuetify/lib/components/VGrid';
import { VExpansionPanels } from 'vuetify/lib/components/VExpansionPanel';
import { VRow } from 'vuetify/lib/components/VGrid';
import { VTextField } from 'vuetify/lib/components/VTextField';
installComponents(component, {VCard,VCol,VContainer,VExpansionPanels,VRow,VTextField})
